
export default class InvestorType {
  type: string;
  confirmed: boolean;
  acceptedRisks?: boolean;
  confirmationMessage?: string;
  accreditationExpired?: boolean;
  filledAptitudeTestId?: string;

  constructor(entity: InvestorType) {
    this.type = entity.type;
    this.confirmed = entity.confirmed;
    this.acceptedRisks = entity.acceptedRisks || undefined;
    this.confirmationMessage = entity.confirmationMessage || undefined;
    this.accreditationExpired = entity.accreditationExpired || undefined;
    this.filledAptitudeTestId = entity.filledAptitudeTestId || undefined;
  }
}



// WEBPACK FOOTER //
// ./src/entities/InvestorType.tsx